import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet, Link, useParams } from "react-router-dom";
import './App.css';
import Home from './components/Home';
import About from './components/About';
import Services from './components/Services';
import Blog from './components/Blog';
import ContactUs from './components/ContactUs';
import Header from './components/Header';
import Footer from "./components/Footer";
import Sidebar from "./components/Sidebar";
import CatList from "./components/CatList";
import Articles from "./components/Articles";
function App() {
  return (
    <div>
      <BrowserRouter>
        <div id="eskimo-site-wrapper">
          <Header />
          <main id="eskimo-main-container">
            <div class="container">
              <Sidebar />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/contact-us" element={<ContactUs />} />

                <Route path="/cat-list/:cat_id" element={<CatList />} />
                <Route path="/articles/:id" element={<Articles />} />
              </Routes>
              <Outlet/>
            </div>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </div>

  );
}

export default App;
